module.exports = __webpack_public_path__ + "img/itunes-black.2928664f.svg";